import cookie from "react-cookies";
import { generateUUID, getCookieConfig } from '../common/utils';

const LOCK_KEY = 'COOKIES_LOCK';
const LOCK_TIMEOUT = 9; // 9 seconds

export const useCookieLock = () => {
  const acquireAutoReleaseLock = (LOCK_KEY: string, LOCK_TIMEOUT: number) => {
    const lockValue = generateUUID();
    let currentLock = cookie.load(LOCK_KEY);

    if (!currentLock) {
      currentLock = cookie.load(LOCK_KEY);
      if (!currentLock) {
        cookie.save(LOCK_KEY, lockValue, getCookieConfig(LOCK_TIMEOUT));
        currentLock = cookie.load(LOCK_KEY);
      }
    }
    return currentLock === lockValue;
  };

  return { acquireAutoReleaseLock };
}